export default "__VITE_ASSET__30da69d4__"